module.exports = __webpack_public_path__ + "static/AkkuratPro-Italic-361e332dfa6a777e76d0d9c1545f7c4b.woff2";